import { transformDateValue } from 'core/js/FormUtils';
export const getStockoutproducttoproductorderView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let stockoutproducttoproductorderList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"stockoutproductid","fieldValue":transformDataValue(data.stockoutproductid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"productorderid","fieldValue":transformDataValue(data.productorderid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Order Id","fieldValue":transformDataValue(data.orderid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Qty","fieldValue":transformDataValue(data.qty,"number"), "fieldType":"number"},
                            {"fieldLabel":"Stock Out Req Id","fieldValue":transformDataValue(data.stockoutreqid,"ID"), "fieldType":"ID"},
              
              
            ],
            'dataList': [
                
              ]
          }

          stockoutproducttoproductorderList.push(card);
  })
  return stockoutproducttoproductorderList;
}